var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Trash1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.2,
    height: 16,
    viewBox: "0 0 15.2 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-trash",
    d: "M12.6,4A2.809,2.809,0,0,0,9.832,6.4H7.1a.539.539,0,0,0-.192,0H5.6a.6.6,0,1,0,0,1.2h.855L7.462,18.012A2.208,2.208,0,0,0,9.652,20h5.895a2.207,2.207,0,0,0,2.19-1.988L18.744,7.6H19.6a.6.6,0,1,0,0-1.2H18.3a.6.6,0,0,0-.192,0H15.368A2.809,2.809,0,0,0,12.6,4Zm0,1.2a1.585,1.585,0,0,1,1.545,1.2H11.055A1.585,1.585,0,0,1,12.6,5.2ZM7.66,7.6h9.879l-1,10.3a.992.992,0,0,1-1,.9H9.652a.993.993,0,0,1-1-.9Zm3.53,1.991a.6.6,0,0,0-.591.609v6a.6.6,0,1,0,1.2,0v-6a.6.6,0,0,0-.609-.609Zm2.8,0a.6.6,0,0,0-.591.609v6a.6.6,0,1,0,1.2,0v-6a.6.6,0,0,0-.609-.609Z",
    transform: "translate(-5 -4)",
    fill: "#ff4d4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Trash1);
export default __webpack_public_path__ + "static/media/icons8-trash1.488dcaec0f615622c74b589f897d21fd.svg";
export { ForwardRef as ReactComponent };